import { render, staticRenderFns } from "./TeamSlide.vue?vue&type=template&id=ac63cafc&scoped=true"
import script from "./TeamSlide.vue?vue&type=script&lang=js"
export * from "./TeamSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac63cafc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac63cafc')) {
      api.createRecord('ac63cafc', component.options)
    } else {
      api.reload('ac63cafc', component.options)
    }
    module.hot.accept("./TeamSlide.vue?vue&type=template&id=ac63cafc&scoped=true", function () {
      api.rerender('ac63cafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/TeamSlide.vue"
export default component.exports